"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/MRFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_157)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_157`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H30V24H-6V0Z",
					fill: "#006233"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H30V3.22807H-6V0ZM-6 20.7719H30V24H-6V20.7719Z",
					fill: "#CD2A3E"
				}),
				/* @__PURE__ */ n("path", {
					d: "M11.9649 13.9545C8.73993 13.9545 6.04576 11.6879 5.38477 8.66119C5.28083 9.13538 5.2283 9.6194 5.22807 10.1048C5.22807 13.8255 8.24414 16.8417 11.9649 16.8417C15.6857 16.8417 18.7018 13.8255 18.7018 10.1048C18.7018 9.60898 18.6467 9.12646 18.5451 8.66119C17.8841 11.6879 15.1899 13.9545 11.9649 13.9545Z",
					fill: "#FFC400"
				}),
				/* @__PURE__ */ n("path", {
					d: "M11.9648 5.05219L12.5919 6.98215H14.6212L12.9795 8.17485L13.6066 10.1049L11.9648 8.91204L10.3232 10.1049L10.9503 8.17485L9.30862 6.98215H11.3377L11.9648 5.05219Z",
					fill: "#FFC400"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_157`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as MRFlag };
